export const theme = {
  fonts: {
    primary: "'Roboto', sans-serif",
  },
  colors: {
    primary: '#007E7A',
    primary50: '#EEFFFC',
    primary100: '#C5FFF8',
    primary200: '#8BFFF1',
    primary300: '#8BFFF1',
    primary400: '#4AFEEA',
    primary500: '#b6c5e7',
    primary600: '#7696d6',
    primary700: '#5984cc',
    primary800: '#066968',
    primary900: '#0A5755',
    secondary: '#ECB11F',
    secondary50: '#FDF9E9',
    secondary100: '#FAF2C7',
    secondary200: '#F7E291',
    secondary300: '#F2CB52',
    secondary500: '#DC9B16',
    secondary600: '#BE7710',
    secondary700: '#985410',
    secondary800: '#7E4415',
    secondary900: '#6B3818',
    neutral: '#FFFFFF',
    neutral50: '#F7F8FB',
    neutral100: '#DFE2E5',
    neutral200: '#C8CBD0',
    neutral300: '#B1B5BB',
    neutral400: '#9AA0A7',
    neutral500: '#858B93',
    neutral600: '#70767E',
    neutral700: '#5D626A',
    neutral800: '#4A4F55',
    neutral900: '#282B2E',
    neutral1000: '#000000',
    red50: '#FEF2F2',
    red100: '#FFE2E2',
    red200: '#FFC9C9',
    red300: '#FFA2A2',
    red400: '#FF6467',
    red500: '#FB2C36',
    red600: '#E7000B',
    red700: '#C10007',
    red800: '#9F0712',
    red900: '#82181A',
    green50: '#F0FDF4',
    green100: '#DCFCE7',
    green200: '#B9F8CF',
    green300: '#7BF1A8',
    green400: '#05DF72',
    green500: '#00C951',
    green600: '#00A63E',
    green700: '#008236',
    green800: '#016630',
    green900: '#0D542B',
    blue50: '#F0F9FF',
    blue100: '#DFF2FE',
    blue200: '#B8E6FE',
    blue300: '#74D4FF',
    blue400: '#00BCFF',
    blue500: '#00A6F4',
    blue600: '#0084D1',
    blue700: '#0069A8',
    blue800: '#00598A',
    blue900: '#024A70',
  },
  sizes: {
    xs: '8px',
    '2xs': '12px',
    sm: '16px',
    '2sm': '20px',
    md: '24px',
    '2md': '28px',
    lg: '32px',
    xl: '40px',
    '2xl': '48px',
    '3xl': '56px',
    '4xl': '64px',
    '5xl': '72px',
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1200px',
  },
} as const;
